import { DEFAULT_API_CONFIG } from './apiConfig';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/selfInspectImageConfig`;

export const getSelfInspectImageConfigs = async () => {
  const response = await fetch(baseRoute, {
    method: 'GET',
    headers: getHeaders(),
  });
  return response.ok ? response.json() : Promise.reject(response);
};

export const getSelfInspectImageConfigPropertyTypes = async () => {
  const response = await fetch(`${baseRoute}/propertyTypes`, {
    method: 'GET',
    headers: getHeaders(),
  });
  return response.ok ? response.json() : Promise.reject(response);
};

export const getSelfInspectImageConfigProducts = async () => {
  const response = await fetch(`${baseRoute}/products`, {
    method: 'GET',
    headers: getHeaders(),
  });
  return response.ok ? response.json() : Promise.reject(response);
};

export const createSelfInspectImageConfig = async (config) => {
  const response = await fetch(baseRoute, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(config),
  });
  if (response.ok) return response.json();
  return Promise.reject(response);
};

export const updateSelfInspectImageConfig = async (id, config) => {
  const response = await fetch(`${baseRoute}/${id}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(config),
  });
  if (response.ok) return true;
  return Promise.reject(response);
};

export const deleteSelfInspectImageConfig = async (id) => {
  const response = await fetch(`${baseRoute}/${id}`, {
    method: 'DELETE',
    headers: getHeaders(),
  });
  if (response.ok) return true;
  return Promise.reject(response);
};
